import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Navbar from './components/Navbar';
import ToastContainer from './components/Toast';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Dashboard from './pages/Dashboard';
import Biblioteca from './pages/Biblioteca';
import CrearRecorrido from './pages/CrearRecorrido';
import EditarRecorrido from './pages/EditarRecorrido';
import EditarHotspots from './pages/EditarHotspots';
import Visor360 from './pages/Visor360';
import Perfil from './pages/Perfil';
import AdminPanel from './pages/AdminPanel';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <ToastContainer />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Registro />} />
            <Route path="/visor/:codigo" element={<Visor360 />} />
            <Route path="/visor/id/:id" element={<Visor360 />} />
            
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/biblioteca"
              element={
                <PrivateRoute>
                  <Biblioteca />
                </PrivateRoute>
              }
            />
            <Route
              path="/crear-recorrido"
              element={
                <PrivateRoute>
                  <CrearRecorrido />
                </PrivateRoute>
              }
            />
            <Route
              path="/editar-recorrido/:id"
              element={
                <PrivateRoute>
                  <EditarRecorrido />
                </PrivateRoute>
              }
            />
            <Route
              path="/editar-hotspots/:id"
              element={
                <PrivateRoute>
                  <EditarHotspots />
                </PrivateRoute>
              }
            />
            <Route
              path="/perfil"
              element={
                <PrivateRoute>
                  <Perfil />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

